import api from "@/api/zfb/auth";
import { Service_SetZfbMemberInfo } from "@/service/platform_config";

async function SetUserInfoToLocal(token) {
  const { result } = await api.GetCurrentUserData(token);
  if ((result?.shop_id || result?.auth?.shop_id) && (result.token || result?.auth?.token)) {
    Service_SetZfbMemberInfo(result.auth ? result.auth : result);
  }
}

export default {
  SetUserInfoToLocal,
};
